import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from 'src/environments/environment';

export const oktaAuth = new OktaAuth({
  issuer: environment.issuer,
  clientId: environment.clientId,
  redirectUri: environment.redirectUri,
  postLogoutRedirectUri:environment.postLogoutRedirectUri,
  scopes: [
    'openid',
    'profile',
    'email',
    "address",
    "phone",
    "groups"],
  pkce: true,
 
  storageManager: {
    token: {
      storageTypes: ['localStorage', 'sessionStorage', 'cookie'], 
    },
    transaction: {
      storageTypes: ['memory'],
    },
  }
});